module.exports = __webpack_public_path__ + "static/media/hoogle_logo.78a110b2.png";